import React from 'react';
import './index.scss';
import { Gb, Dk, De, Fr, Es } from 'react-flags-select';
import Select, { SingleValue, components } from 'react-select';
import { Language } from 'Types/Language';
import axios from '../../services/request';

interface Props {
  onSelect: (code: string) => void;
  selected: string;
  placeholder?: string;
  label?: string;
  error?: Array<string>;
}

const LanguageFormSelect = ({
  onSelect,
  selected,
  error,
  placeholder,
  label,
}: Props) => {
  const [options, setOptions] = React.useState<Language[]>([]);
  const [languages, setLanguages] = React.useState<Language[]>([]);
  const fetchLanguages = async () => {
    try {
      const { data } = await axios.get(`/languages/`);
      /* let os = data?.map((obj: Language) => ({ label: obj.name, value: obj.language }))||[]; */
      const os = data.sort((a: Language, b: Language) =>
        a.name > b.name ? 1 : -1
      );
      setOptions(os);
      setLanguages(data);
    } catch (err) {
      // Can't show a translated error message if loading the language IDs failed.
      // We should consider exception logging into Azure https://learn.microsoft.com/en-us/azure/azure-monitor/app/javascript?tabs=snippet#examples
      console.error(err); // eslint-disable-line no-console
    }
  };

  React.useEffect(() => {
    fetchLanguages();
  }, []);

  const getFlag = (code: string) => {
    if (code === 'en') return <Gb />;
    if (code === 'da') return <Dk />;
    if (code === 'de') return <De />;
    if (code === 'fr') return <Fr />;
    if (code === 'fr') return <Fr />;
    if (code === 'es') return <Es />;
    return <Gb />;
  };

  const handleSelect = async (code: string) => {
    onSelect(code);
  };

  const DropdownIndicator = (props: any) => (
    <components.DropdownIndicator {...props}>
      {!!selected && getFlag(selected)}
    </components.DropdownIndicator>
  );

  return (
    <div className="language-form-select">
      {label && (
        <label htmlFor="languageCode" className="label">
          {' '}
          {label}
        </label>
      )}
      <Select
        options={options}
        value={languages?.find((x) => x.language === selected)}
        onChange={(val: SingleValue<Language>) => {
          handleSelect(val?.language || '');
        }}
        isSearchable={false}
        placeholder={placeholder}
        name={'language'}
        components={{ DropdownIndicator }}
        getOptionLabel={(option: Language) => option.name}
        getOptionValue={(option: Language) => option.language}
      />
      {error && (
        <div
          className="ui pointing above prompt label"
          role="alert"
          aria-atomic="true"
        >
          {error.map((e: string) => (
            <span key={e}>{e}</span>
          ))}
        </div>
      )}
    </div>
  );
};

LanguageFormSelect.defaultProps = {};

export default LanguageFormSelect;
